// i18n area 'storage' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.el-GR.meta.json.
import type { enUS } from './storage'

export const elGR: typeof enUS = {
  storage: {
    pools: {
      title: 'Αποθήκευση',
      createTitle: 'Δημιουργία χώρου αποθήκευσης',
      path: 'Διαδρομή',
      pathHint: 'Απόλυτη διαδρομή κάτω από μια επιτρεπόμενη root (προεπιλογή /var/lib/tvirt/pools/)',
      shared: 'Κοινόχρηστος χώρος αποθήκευσης',
      sharedChip: 'κοινόχρηστος',
      sharedVerifiedChip: 'κοινόχρηστος · επαληθευμένος',
      sharedVerifiedTooltip: 'Κοινή χρήση επαληθευμένη: οι διασταυρούμενες ανιχνεύσεις επιβεβαιώνουν ότι κάθε μέλος βλέπει τα δεδομένα που γράφουν τα άλλα.',
      sharedDisputedChip: 'κοινόχρηστος · ΜΗ επαληθευμένος',
      sharedDisputedTooltip: 'Κοινή χρήση ΜΗ επαληθευμένη',
      sharedDisputedPair: 'Ο {observer} δεν βλέπει τα δεδομένα που έγραψε ο {writer}',
      sharedHint: 'Ένας κοινόχρηστος πόρος δικτύου προσαρτημένος τοπικά στην ίδια διαδρομή σε κάθε μέλος — το προαπαιτούμενο της live migration (δηλωτικό).',
      sharedDanger: 'ΚΙΝΔΥΝΟΣ — το TVirt ΠΙΣΤΕΥΕΙ αυτό το flag: ενεργοποιώντας το, κάθε μέλος υποθέτει ότι βλέπει τα ΙΔΙΑ byte σε αυτή τη διαδρομή. Σε έναν φάκελο που ΔΕΝ είναι ένας πραγματικά κοινόχρηστος πόρος (NFS/CIFS/σύστημα αρχείων συστοιχίας) το αποτέλεσμα είναι αλλοίωση και απώλεια δεδομένων στην πρώτη μετεγκατάσταση ή στην πρώτη επανεκκίνηση HA σε άλλον κόμβο. Ενεργοποιήστε το μόνο αν η διαδρομή είναι ένας κοινόχρηστος πόρος προσαρτημένος πανομοιότυπα σε κάθε κόμβο.',
      type: 'Τύπος',
      capacity: 'Χωρητικότητα',
      provisioned: 'Εκχωρημένη',
      provisionedOvercommit: 'Δυνητική εκχώρηση πέρα από τη χωρητικότητα: οι τόμοι thin μπορούν να μεγαλώσουν έως {n} GiB.',
      phase: { ready: 'Έτοιμος', degraded: 'Υποβαθμισμένος', error: 'Σφάλμα' },

      // Γύρος #156 (πρότυπο διαλόγου): ο ΠΛΗΡΗΣ διάλογος λεπτομερειών — καρτέλες,
      // οι γραμμές διαμόρφωσης ανά driver και η παρατηρούμενη επιφάνεια.
      tabConfig: 'Διαμόρφωση',
      tabCapacity: 'Χωρητικότητα και κατάσταση',
      cardIdentity: 'Ταυτότητα',
      cardPlacement: 'Τοποθέτηση',
      cardConnection: 'Σύνδεση',
      usedReal: 'Πραγματική χρήση',
      capacityUnknown: 'Ο κόμβος δεν έχει αναφέρει ακόμη τη χωρητικότητα αυτού του pool — εδώ δεν εφευρίσκονται αριθμοί',
      overcommitHint: 'Εκχώρηση πάνω από τη χωρητικότητα: θεμιτή στα pool thin, προσέχετε την πραγματική χρήση',
      supportedContent: 'Υποστηριζόμενα περιεχόμενα',
      content: {
        disks: 'Δίσκοι',
        catalogFiles: 'Αρχεία καταλόγου',
        backups: 'Backup',
        appVolumes: 'Τόμοι App'
      },
      defaultDiskFormat: 'Προεπιλεγμένη μορφή δίσκου',
      reserveGiB: 'Δεσμευμένος ελεύθερος χώρος (GiB)',
      available: 'Διαθέσιμος',
      diskCount: 'Δίσκοι',
      filesystem: 'Σύστημα αρχείων',
      observedAt: 'Παρατηρήθηκε στις',
      lostAtRow: 'Δηλώθηκε χαμένος στις',
      sharedProbeRow: 'Επαλήθευση κοινής χρήσης',
      sharedProbeNodes: 'Κόμβοι που ανιχνεύθηκαν',
      reachableFrom: 'Δηλωμένη προσβασιμότητα',
      reachableFromHint: 'Οι κόμβοι από τους οποίους αυτός ο χώρος αποθήκευσης πρέπει να είναι προσβάσιμος. Μια VM με δίσκους, ISO ή μεταδεδομένα εδώ πάνω δεν εκκινεί ούτε μετεγκαθίσταται σε κόμβο εκτός αυτής της λίστας. Όλα τα μέλη είναι προεπιλεγμένα: περιορίστε όπως θέλετε. Ένας κόμβος που μπαίνει στη συστοιχία αργότερα μένει εκτός μέχρι να τον προσθέσετε εδώ.',
      reachableFromNone: 'μη δηλωμένη',
      reachableFromTags: 'Προσβασιμότητα ανά ετικέτα',
      reachableFromTagsHint: 'Επιλογέας ετικέτα=τιμή (καταχωρίσεις διαχωρισμένες με κόμμα, σε AND): κάθε μέλος που φέρει αυτές τις ετικέτες δηλώνεται προσβάσιμο — δυναμικά: η προσθήκη ετικέτας σε έναν κόμβο τον φέρνει μέσα.',
      reachableFromTagsInvalid: 'Μη έγκυρη μορφή — χρησιμοποιήστε ετικέτα=τιμή, διαχωρισμένα με κόμμα',
      reachableResolved: 'Επιλυμένοι κόμβοι: {nodes}',
      reachableDeclaredNotSeen: 'δηλωμένος αλλά μη ορατός από την ανίχνευση κοινής χρήσης σε: {nodes}',
      reachableSeenNotDeclared: 'ορατός αλλά μη δηλωμένος (εκτός περιμέτρου) σε: {nodes}',
      cephCluster: 'Διαχειριζόμενη συστοιχία Ceph',
      appGuardTitle: 'Χώρος αποθήκευσης σε χρήση από App',
      appEphemeralGuard: 'αυτός ο χώρος αποθήκευσης είναι το εφήμερο pool συστοιχίας των App — αλλάξτε το πρώτα από τη σελίδα App, μετά διαγράψτε τον.',
      appInUseGuard: 'εδώ ζουν root/τόμοι από app: {apps} — μετακινήστε ή διαγράψτε τα πρώτα.',
      releaseRequiredTitle: 'Διαγραφή του «{name}» και αποδέσμευση των εικόνων του;',
      releaseRequiredBatchTitle: 'Διαγραφή των επιλεγμένων storage και αποδέσμευση των εικόνων τους;',
      releaseRequiredBody: 'Η αποδέσμευση των εικόνων ΔΕΝ διαγράφει κανένα byte: η απο-καταχώριση αφήνει το namespace στον δίσκο, οι εικόνες απλώς παύουν να είναι υλοποιημένες και κάθε αναφορά των scope επιβιώνει ως claim — καταχωρίστε ξανά το pool και υιοθετούνται εκ νέου.',
      releaseConfirm: 'Διαγραφή και αποδέσμευση των εικόνων'
    },
    lost: {
      chip: 'Χαμένος',
      action: 'Δήλωση απώλειας',
      confirmTitle: 'Δήλωση του χώρου αποθήκευσης ως χαμένου',
      confirmBody: 'Βεβαίωση του χειριστή με δικό σας δηλωμένο ρίσκο: κάθε εργασία σε ουρά ή σε εξέλιξη πάνω σε αυτόν τον χώρο αποθήκευσης ή στα αντικείμενά του θα ΑΠΟΤΥΧΕΙ, οι διαγραφές γίνονται μόνο στο μητρώο (καμία δουλειά στο σύστημα αρχείων) και η νέα φυσική δουλειά απορρίπτεται. Τα byte δεν αγγίζονται ποτέ — αν ο τόμος επανέλθει στη ζωή, καταχωρίστε τον ξανά και εκτελέστε μια σάρωση για να υιοθετηθούν ξανά όλα.',
      confirmSubmit: 'Δήλωση απώλειας',
      error: 'Η βεβαίωση απορρίφθηκε'
    },
    findings: {
      action: 'Αντικείμενα που βρέθηκαν',
      title: 'Αντικείμενα που βρέθηκαν',
      empty: 'Κανένα αντικείμενο δεν βρέθηκε στο namespace του χώρου αποθήκευσης',
      loadError: 'Αδυναμία φόρτωσης των αντικειμένων που βρέθηκαν',
      actionError: 'Η απόφαση απορρίφθηκε',
      colKind: 'Τύπος',
      colObject: 'Αντικείμενο',
      colConflict: 'Σύγκρουση',
      namespaceNotice:
        'Αυτός ο κατάλογος είχε ήδη αρχικοποιηθεί από άλλον αποθηκευτικό χώρο: η σφραγίδα ταυτότητας ξαναγράφτηκε με εκείνη αυτού του αποθηκευτικού χώρου. Τα περιεχόμενα ΔΕΝ πειράχτηκαν — δες τα αντικείμενα που βρέθηκαν παρακάτω, εισήγαγε όσα χρειάζεσαι και μετά απόρριψε αυτή την ειδοποίηση.',
      kind: {
        disk: 'Δίσκος',
        catalogFile: 'Αρχείο καταλόγου',
        vmMetadata: 'Metadata VM',
        namespace: 'Namespace',
        foreign: 'Ξένο',
        volumeGroup: 'Ομάδα τόμων'
      },
      vgAdopt: {
        action: 'Υιοθέτηση της ομάδας τόμων',
        title: 'Υιοθέτηση της ομάδας τόμων',
        intro:
          'Αυτή η συσκευή φέρει ήδη μια ομάδα τόμων με όνομα του TVirt, αλλά η σφραγίδα της δεν ονομάζει κανένα storage καταχωρημένο εδώ. Μπορεί να είναι ό,τι άφησε στο LUN ένα προηγούμενο storage ΑΥΤΟΥ του cluster — ή ό,τι άφησε ΑΛΛΟ cluster TVirt σε ένα LUN που άλλαξε χέρια: από εδώ οι δύο περιπτώσεις φαίνονται ίδιες, και γι\' αυτό κανείς δεν αποφασίζει για εσάς.',
        irreversible: 'Δείτε τη συσκευή, τη σφραγίδα και το όνομα πριν συνεχίσετε: η υιοθέτηση δεν αναιρείται.',
        device: 'Συσκευή',
        seal: 'Σφραγίδα',
        sealNone: 'καμία (χωρίς ετικέτα tvirt.storageId)',
        renameTo: 'Θα μετονομαστεί σε',
        renameNone: 'Χωρίς μετονομασία: το όνομα είναι ήδη αυτό που παράγει αυτό το storage',
        volumesNote:
          'Οι τόμοι που περιέχει ΔΕΝ υιοθετούνται με αυτή την κίνηση: η επόμενη σάρωση τους προσφέρει έναν προς έναν, ως συνηθισμένα ευρεθέντα αντικείμενα.'
      },
      conflictChip: 'Το ID υπάρχει ήδη',
      dismissedChip: 'Αγνοημένο',
      adopt: 'Υιοθέτηση',
      adoptFileTitle: 'Εισαγωγή σε κατάλογο',
      adoptFileHint: 'Τα αρχεία υπάρχουν μόνο μέσα σε καταλόγους: επιλέξτε τον κατάλογο προορισμού για το αρχείο που βρέθηκε.',
      purge: 'Διαγραφή από τον δίσκο',
      dismiss: 'Αγνόηση',
      purgeConfirmTitle: 'Διαγραφή από τον δίσκο',
      purgeConfirmBody: 'Τα byte του «{id}» που βρέθηκαν θα αφαιρεθούν από τον χώρο αποθήκευσης. Η ενέργεια δεν είναι αναστρέψιμη.',
      taskStarted: 'Ξεκίνησε — συνεχίζει ως εργασία στο παρασκήνιο',
      scan: 'Σάρωση του χώρου αποθήκευσης',
      scanStarted: 'Η σάρωση ξεκίνησε…',
      scanDone: 'Η σάρωση ολοκληρώθηκε — τα αντικείμενα που βρέθηκαν είναι ενημερωμένα'
    },
    reinit: {
      action: 'Νέα προσπάθεια αρχικοποίησης'
    },
    wizard: {
      addButton: 'Προσθήκη',
      title: 'Προσθήκη χώρου αποθήκευσης',
      back: 'Πίσω',
      continue: 'Συνέχεια',
      selectHint: 'Επιλέξτε ένα πρωτόκολλο για να δείτε πώς το χρησιμοποιεί το TVirt.',
      roadmap: 'Roadmap',
      server: 'Διακομιστής',
      export: 'Εξαγόμενη διαδρομή',
      share: 'Share',
      username: 'Όνομα χρήστη',
      password: 'Κωδικός πρόσβασης',
      passwordHint: 'Μόνο εγγραφής: χρησιμοποιείται για το mount, δεν εμφανίζεται ποτέ ξανά.',
      credential: 'Διαπιστευτήριο',
      credentialManual: 'Χειροκίνητη εισαγωγή',
      credentialHint: 'Μια καταχώριση του keystore τύπου όνομα χρήστη και κωδικός πρόσβασης — η εναλλακτική στο να τα πληκτρολογήσετε εδώ.',
      credentialEmpty: 'Κανένα διαπιστευτήριο τύπου όνομα χρήστη και κωδικός πρόσβασης στο keystore — δημιουργήστε το στο Σύστημα → Διαπιστευτήρια, ή πληκτρολογήστε τον λογαριασμό εδώ κάτω.',
      options: 'Επιλογές mount',
      optionsHint: 'Διαχωρισμένες με κόμμα, περνούν στο mount -o όπως είναι.',
      portal: 'Portal',
      portalHint: 'host[:θύρα] — η προεπιλεγμένη θύρα είναι 3260.',
      target: 'Target IQN',
      targetHint: 'Το όνομα του target iSCSI, ξεκινά με iqn.',
      lun: 'LUN',
      wholeLunRow: 'Στους δίσκους: αυτός ο αποθηκευτικός χώρος ονομάζει μόνο τον target',
      wholeLunHint: 'Αυτός ο αποθηκευτικός χώρος ονομάζει μόνο τον target: τα LUN του γίνονται δίσκοι ένα-ένα (Δημιουργία δίσκου → υιοθέτηση ολόκληρου LUN), στον target δεν γράφεται τίποτα.',
      lunHint: 'Αριθμός του LUN στο target — 0 σε περίπτωση αμφιβολίας.',
      chapCredential: 'Διαπιστευτήριο (CHAP)',
      chapCredentialHint: 'Μια καταχώριση του keystore τύπου CHAP (iSCSI) που χρησιμοποιείται για το login — το μυστικό δεν ταξιδεύει ποτέ με τον χώρο αποθήκευσης.',
      chapNone: 'Χωρίς έλεγχο ταυτότητας',
      chapEmpty: 'Κανένα διαπιστευτήριο τύπου CHAP (iSCSI) στο keystore — δημιουργήστε το στο Σύστημα → Διαπιστευτήρια. Χωρίς αυτό, το login μένει χωρίς έλεγχο ταυτότητας.',
      address: 'Διεύθυνση',
      addressHint: 'Host ή IP του target NVMe/TCP (traddr).',
      port: 'Θύρα',
      portHint: 'Θύρα TCP του target — 4420 αν μείνει κενή.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'Το NQN του subsystem στο target, ξεκινά με nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID μέσα στο subsystem — 1 σε περίπτωση αμφιβολίας.',
      dhchapCredential: 'Διαπιστευτήριο (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Μια καταχώριση του keystore τύπου DH-HMAC-CHAP (NVMe) που χρησιμοποιείται κατά τη σύνδεση — το μυστικό δεν ταξιδεύει ποτέ με τον χώρο αποθήκευσης.',
      dhchapNone: 'Χωρίς έλεγχο ταυτότητας',
      dhchapEmpty: 'Κανένα διαπιστευτήριο τύπου DH-HMAC-CHAP (NVMe) στο keystore — δημιουργήστε το στο Σύστημα → Διαπιστευτήρια. Χωρίς αυτό, η σύνδεση μένει χωρίς έλεγχο ταυτότητας.',
      monitors: 'Monitor',
      monitorsHint: 'Endpoint των monitor Ceph, host[:θύρα], διαχωρισμένα με κόμμα ή με αλλαγή γραμμής — προεπιλεγμένη θύρα 6789.',
      pool: 'Pool',
      poolHint: 'Το pool RBD προς κατανάλωση — μία εικόνα RBD ανά δίσκο.',
      fs: 'Σύστημα αρχείων',
      fsHint: 'Το όνομα του συστήματος αρχείων CephFS (mds_namespace κατά το mount).',
      fsPath: 'Διαδρομή μέσα στο σύστημα αρχείων',
      fsPathHint: 'Απόλυτη διαδρομή μέσα στο σύστημα αρχείων που προσαρτά ο χώρος αποθήκευσης — / σε περίπτωση αμφιβολίας.',
      cephxCredential: 'Διαπιστευτήριο (cephx)',
      cephxCredentialHint: 'Μια καταχώριση του keystore τύπου cephx: username = όνομα client (client.…), secret = το κλειδί base64. Υποχρεωτική.',
      cephxNone: 'Κανένα διαπιστευτήριο cephx στο keystore — δημιουργήστε ένα (τύπος: cephx) στο Σύστημα → Διαπιστευτήρια, ή αφήστε μια διαχειριζόμενη συστοιχία Ceph να το παράγει με το «Πρόταση ως χώρος αποθήκευσης».',
      sharedByNature: 'Οι δικτυακοί χώροι αποθήκευσης είναι κοινόχρηστοι εκ φύσεως: κάθε μέλος τους προσαρτά στην ίδια διαδρομή που διαχειρίζεται το TVirt.',
      error: 'Ο χώρος αποθήκευσης απορρίφθηκε',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Άλλο',
        legacy: 'Legacy'
      },
      legacyHint: 'Πλήρως υποστηριζόμενα — απλώς δεν θα τα επιλέγαμε για μια νέα εγκατάσταση.',
      proto: {
        // Η γραμμή `usage` (Luca 2026-07-24) λέει πώς το TVirt χρησιμοποιεί το
        // πρωτόκολλο — πρωτίστως τα αποδεκτά περιεχόμενα: τα dir/nfs/cifs φιλοξενούν
        // δίσκους ΚΑΙ εικόνες ISO/δίσκου και πρότυπα, οι driver μπλοκ
        // (iscsi/nvme-tcp/rbd) ΜΟΝΟ δίσκους.
        dir: {
          name: 'Τοπικός φάκελος',
          desc: 'Ένα directory στον κόμβο: απλό και γρήγορο. Είναι ΤΟΠΙΚΟ σε έναν κόμβο, εκτός αν η διαδρομή είναι ένας πραγματικά κοινόχρηστος πόρος — το να το μαρκάρετε κοινόχρηστο όταν δεν είναι κοστίζει δεδομένα.',
          usage: 'Το TVirt αποθηκεύει εκεί δίσκους των VM, εικόνες ISO/δίσκου και πρότυπα.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Ένα export NFS προσαρτημένο από τη συστοιχία — κοινόχρηστο εκ φύσεως.',
          usage: 'Φιλοξενεί δίσκους των VM, εικόνες ISO/δίσκου και πρότυπα.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Ένας κοινόχρηστος πόρος Windows/Samba προσαρτημένος από τη συστοιχία — κοινόχρηστος εκ φύσεως.',
          usage: 'Φιλοξενεί δίσκους των VM, εικόνες ISO/δίσκου και πρότυπα.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Ένα απομακρυσμένο σύστημα αρχείων μέσω SSH — χωρίς ανάγκη για export NAS.',
          usage: 'Σε roadmap.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'LUN μπλοκ μέσω IP με κοινόχρηστο LVM από πάνω.',
          usage: 'Μόνο δίσκοι — ένας τόμος thin ανά δίσκο· δεν φιλοξενεί εικόνες ISO ούτε πρότυπα.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Κατανεμημένα block device σε μια συστοιχία Ceph.',
          usage: 'Μόνο δίσκοι — μία εικόνα RBD ανά δίσκο, που ανοίγεται εγγενώς από το QEMU· δεν φιλοξενεί εικόνες ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Το κατανεμημένο σύστημα αρχείων του Ceph, προσαρτημένο από τον kernel στη συστοιχία — shared by nature.',
          usage: 'Φιλοξενεί δίσκους VM, εικόνες ISO/δίσκου και πρότυπα — η οικογένεια dir πάνω σε ένα σύστημα αρχείων Ceph (διαπιστευτήριο cephx υποχρεωτικό).'
        },
        fc: { name: 'SCSI/FC', desc: 'LUN SCSI σε fabric FibreChannel — η κλασική SAN FC.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Το ίδιο SCSI πάνω σε FibreChannel, με τα frame FC ενθυλακωμένα σε Ethernet.' },

        // Ζωντανό από τον γύρο #132 — το κλειδί είναι το όνομα του driver στο
        // contract, έτσι το chip της λίστας αποθήκευσης επιλύει την ίδια καταχώριση.
        'iscsi-lun': {
          name: 'iSCSI (ολόκληρα LUN)',
          desc: 'Ο target iSCSI ως φορέας ολόκληρων LUN: κάθε δίσκος ΕΙΝΑΙ ένα LUN, που περνά ωμό στον επισκέπτη — χωρίς LVM ενδιάμεσα.',
          usage: 'Μόνο δίσκοι — ένα ολόκληρο LUN ανά δίσκο, υιοθετημένο ως έχει· το SAN σπίτι των δίσκων κοινόχρηστης εγγραφής.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (ολόκληρα namespace)',
          desc: 'Το υποσύστημα NVMe ως φορέας ολόκληρων namespace: κάθε δίσκος ΕΙΝΑΙ ένα namespace, που περνά ωμό στον επισκέπτη.',
          usage: 'Μόνο δίσκοι — ένα ολόκληρο namespace ανά δίσκο, υιοθετημένο ως έχει· κοινόχρηστη εγγραφή ναι, SCSI persistent reservations όχι.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Απομακρυσμένο NVMe — κανένα SCSI στη διαδρομή — πάνω σε απλό TCP, με κοινόχρηστο LVM από πάνω.',
          usage: 'Μόνο δίσκοι — ένας τόμος thin ανά δίσκο· δεν φιλοξενεί εικόνες ISO ούτε πρότυπα.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Απομακρυσμένο NVMe σε fabric FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe πάνω στο fabric FibreChannel που το FCoE μεταφέρει μέσα σε Ethernet — τα επίπεδα FCoE και NVMe/FC στοιβαγμένα.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI με τη διαδρομή δεδομένων μεταφερμένη σε RDMA — οποιοδήποτε fabric (InfiniBand, iWARP, RoCE). Ξεπερασμένο από το NVMe/RDMA, ακόμη παρόν στα array και στο ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Εγγενές SCSI πάνω σε RDMA, η προ-iSER εποχή: InfiniBand (με discovery του fabric) και RoCE — επιβιώνει σε παλαιωμένους χώρους αποθήκευσης HPC.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Απομακρυσμένο NVMe σε οποιοδήποτε fabric RDMA — InfiniBand, iWARP, RoCE v1 και v2: μία μόνο διαμόρφωση, ο κόμβος λέει ποιο έχει.' },
        s3: { name: 'S3', desc: 'Object storage συμβατός με S3 — εικόνες και αντίγραφα ασφαλείας.' }
      }
    },
    catalogs: {
      title: 'Κατάλογοι',
      createTitle: 'Δημιουργία καταλόγου',
      editTitle: 'Επεξεργασία καταλόγου',
      docTitle: 'Κατάλογος',
      notFound: 'Αυτός ο κατάλογος δεν υπάρχει (πια;)',
      scopeHint: 'Όποιος διαβάζει αυτό το scope βλέπει (και μπορεί να χρησιμοποιεί) κάθε αρχείο του καταλόγου',
      files: 'Αρχεία',
      noFiles: 'Κανένα αρχείο',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Ο κατάλογος συστήματος (γύρος #126): το σπίτι των ενσωματωμένων
      // αντικειμένων της πλατφόρμας — αναγνώσιμος από όλους, εγγράψιμος από κανέναν.
      systemChip: 'συστήματος',
      systemTooltip: 'Κατάλογος συστήματος: φιλοξενεί τα ενσωματωμένα αντικείμενα της πλατφόρμας και δεν μπορεί να τροποποιηθεί'
    },

    // Αρχεία καταλόγου (γύρος K1, inventory v2e/v2g): ο κατάλογος είναι το σπίτι
    // των αδρανών αρχείων-τεχνουργημάτων της συστοιχίας — μία λίστα, τίτλοι ανά kind.
    catalogFiles: {
      catalog: 'Κατάλογος',
      kindLabel: 'Τύπος',
      physicalSize: 'Φυσικό μέγεθος',
      virtualSize: 'Εικονικό μέγεθος',

      // Γύρος K3 (#64) + K4 (#65, ova/ovf με την αντιστοίχιση boot-survival):
      // υλοποιεί ένα αρχείο vm-template ως VM Template της απογραφής.
      importTemplateAction: 'Εισαγωγή ως VM Template',
      importTemplateLegacy: 'Καμία δηλωμένη μορφή — χρησιμοποιήσιμο ως seed για δίσκους, μη εισαγώγιμο',
      importTemplateTitle: 'Εισαγωγή ως VM Template',
      importTemplateSubmit: 'Εισαγωγή',
      importTemplateError: 'Το import απέτυχε',
      importTemplateHint: 'Το πακέτο .tvtpl γίνεται VM Template: το παγωμένο hardware του manifest συν έναν δίσκο ανά entry της αρχειοθήκης, καθέναν επαληθευμένο έναντι του checksum του. Οι NIC και τα μέσα CD/DVD δεν αποτελούν μέρος μιας αρχειοθήκης — προσθέστε τα μετά το import.',
      importTemplateQcow2Hint: 'Ένα γυμνό qcow2 γίνεται πρότυπο ΕΝΟΣ δίσκου με το δηλωμένο προεπιλεγμένο hardware: προφίλ linux, UEFI, 2 vCPU, 2048 MiB, εκκίνηση από τον μοναδικό του δίσκο. Διορθώστε κατά το deploy.',
      importTemplateName: 'Όνομα του προτύπου',
      importTemplateNameHint: 'Κενό = {name} (-import-<n> αν είναι πιασμένο)',
      importTemplateStorage: 'Χώρος αποθήκευσης για τους δίσκους',
      importTemplateMetadataStorage: 'Χώρος αποθήκευσης μεταδεδομένων',
      importTemplateMetadataHint: 'Ένας χώρος αποθήκευσης μπλοκ δεν φιλοξενεί τα μεταδεδομένα VM (firmware, varstore) — επιλέξτε έναν dir/nfs/cifs.',
      importTemplateStarted: 'Το import ξεκίνησε — το πρότυπο εμφανίζεται στην καρτέλα «Πρότυπα» με το κλείσιμο της εργασίας.',

      // Επιγραφές που μιλούν, στον ενικό (#86): τα ευρήματα και η απογραφή λένε
      // ΤΙ είναι το αρχείο — το γενικό «Αρχείο καταλόγου» μένει μόνο ως fallback.
      kind: {
        iso: 'Εικόνα ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Πρότυπο VM',
        'oci-image': 'Εικόνα OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      title: {
        iso: 'Εικόνες ISO',
        'ct-rootfs': 'Πρότυπα CT',
        'vm-template': 'Πρότυπα VM',
        'oci-image': 'Εικόνες OCI',
        'firmware-ovmf': 'Firmware OVMF'
      },
      createTitle: {
        iso: 'Προσθήκη εικόνας ISO',
        'ct-rootfs': 'Καταχώριση προτύπου CT',
        'vm-template': 'Προσθήκη προτύπου VM',
        'oci-image': 'Προσθήκη εικόνας OCI',
        'firmware-ovmf': 'Προσθήκη firmware OVMF'
      },
      formatHint: 'Προκύπτει από την επέκταση του επιλεγμένου αρχείου — διορθώστε το αν μάντεψε λάθος',
      tarballHint: 'Ένα tarball rootfs στην τυπική μορφή LXC (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, ή ένα απλό .tar)',
      ociArchiveHint: 'Ένα tarball docker-archive / oci-archive (.tar ή .tar.gz), για παράδειγμα από docker save',
      uploadResumeHint: 'Το upload διακόπηκε — το αρχείο είναι σε αναμονή upload: υποβάλετε ξανά με το ίδιο αρχείο για να συνεχίσετε',
      moveTitle: 'Μετακίνηση αρχείου',
      moveHint: 'Δύο ανεξάρτητες διαστάσεις: ο Κατάλογος μετακινεί τον σύνδεσμο (ίδιο id, κανένα byte δεν μετακινείται, το scope γίνεται αυτό του καταλόγου προορισμού)· ο Χώρος αποθήκευσης μετακινεί τα δεδομένα — κάθε συνδεδεμένο αντίγραφο το ακολουθεί, απορρίπτεται όσο το αρχείο είναι σε χρήση. Αν επιλεγούν μαζί, πρώτα ο κατάλογος και μετά ο χώρος αποθήκευσης.',
      moveCatalog: 'Κατάλογος προορισμού',
      moveCatalogHint: 'Μόνο ο σύνδεσμος αλλάζει σπίτι: μια VM που έχει προσαρτήσει το αρχείο πρέπει να μπορεί να δει τον κατάλογο προορισμού',
      keepCurrent: 'Χωρίς αλλαγή',
      rehomed: 'Ο σύνδεσμος μετακινήθηκε στον επιλεγμένο κατάλογο',
      copyAction: 'Αντιγραφή σε κατάλογο…',
      copyTitle: 'Αντιγραφή σε κατάλογο',
      copyLinkHint: 'Το αντίγραφο είναι ένας νέος σύνδεσμος στα ίδια δεδομένα — τίποτα δεν διπλασιάζεται στον χώρο αποθήκευσης.',
      copyCatalog: 'Κατάλογος προορισμού',
      copyCatalogHint: 'Η αντιγραφή είναι ο τρόπος με τον οποίο ένα αρχείο ταξιδεύει μεταξύ καταλόγων',
      sameCatalog: 'Ο ίδιος με την προέλευση',
      sharedObjectHint: 'Τα δεδομένα αυτού του αρχείου τα μοιράζονται {count} συνδεδεμένα αντίγραφα',
      deleteLastLink: 'Αυτός είναι ο ΤΕΛΕΥΤΑΙΟΣ σύνδεσμος σε αυτό το περιεχόμενο: θα διαγραφούν και τα δεδομένα από τον χώρο αποθήκευσης.',
      deleteLinkOnly: 'Θα αφαιρεθεί μόνο αυτός ο σύνδεσμος — τα δεδομένα μένουν, ακόμη προσβάσιμα από τα άλλα συνδεδεμένα αντίγραφα ({count}).',
      noCatalog: 'Δεν υπάρχει κανένας κατάλογος — δημιουργήστε έναν',
      inlineCatalogName: 'Όνομα του καταλόγου',

      // Ενσωματωμένα αρχεία της πλατφόρμας (γύρος #126): storage null —
      // διαβάζονται και κλωνοποιούνται, ποτέ move/delete/rename.
      embeddedChip: 'ενσωματωμένο',
      embeddedStorage: 'Ενσωματωμένο στην πλατφόρμα',
      embeddedNoMove: 'Ενσωματωμένο αρχείο της πλατφόρμας: δεν ζει σε κανέναν χώρο αποθήκευσης — κλωνοποιήστε το αντί γι\' αυτό',
      embeddedCopyHint: 'Ο κλώνος υλοποιεί τα ενσωματωμένα byte σε έναν πραγματικό χώρο αποθήκευσης: επιλέξτε χώρο αποθήκευσης και κατάλογο προορισμού — το αντίγραφο είναι ένα κανονικό αρχείο',
      sourceEmbedded: 'Ενσωματωμένο στην πλατφόρμα',
      nodesRow: 'Παρουσία ανά κόμβο',
      nodesSummary: '{present} από {total} κόμβους το έχουν',
      nodePresent: 'υπάρχει',
      nodeMissing: 'λείπει',
      nodeUnknown: 'δεν έχει αναφερθεί ακόμη',
      nodesHint: 'Το asset ζει στον δίσκο κάθε κόμβου (πακέτο trantor-tvirt-assets): ένας κόμβος που δεν το έχει δεν μπορεί ούτε να ορίσει VM με αυτό το firmware ούτε να εξυπηρετήσει τα Guest Tools. Διαφορετικές εκδόσεις μεταξύ κόμβων είναι φυσιολογικές κατά την κυλιόμενη ενημέρωση.',

      // Λήψη (γύρος #108): τα byte ταξιδεύουν με το δικό τους αποκλειστικό δικαίωμα.
      downloadAction: 'Λήψη',
      downloadNotReady: 'Το περιεχόμενο δεν είναι ακόμη έτοιμο — η λήψη απαιτεί ένα αρχείο ready',
      downloadDenied: 'Ο ρόλος σας δεν περιλαμβάνει το catalog.download — η λήψη των byte είναι δικαίωμα ξεχωριστό από τη χρήση του αρχείου',

      // Γύρος #156 (πρότυπο διαλόγου): οι γραμμές ανάγνωσης που έλειπαν από τον
      // διάλογο λεπτομερειών — τα στοιχεία του κοινόχρηστου αντικειμένου, το
      // δηλωμένο checksum, οι χρήστες του.
      objectRow: 'Αντικείμενο αποθήκευσης',
      objectLinksRow: 'Συνδεδεμένα αντίγραφα',
      declaredChecksum: 'Δηλωμένο SHA-256',
      usedByRow: 'Χρησιμοποιείται από',
      usedByVms: 'VM',
      usedByDisks: 'Δίσκοι',
      transferRow: 'Μεταφορά',
      storageLockHint: 'Αλλάζει μόνο με την ενέργεια «Μετακίνηση»'
    },

    // Η απογραφή ανά χώρο αποθήκευσης (γύρος K1, inventory v2b #2): μόνο για
    // ανάγνωση, η διαχείριση κάθε αντικειμένου γίνεται από τη δική του ενότητα.
    objects: {
      action: 'Εξερεύνηση περιεχομένων',
      title: 'Περιεχόμενα του χώρου αποθήκευσης',
      hint: 'Απογραφή μόνο για ανάγνωση του τι ζει σε αυτόν τον χώρο αποθήκευσης — η διαχείριση κάθε αντικειμένου γίνεται από τη δική του ενότητα.',
      empty: 'Κανένα αντικείμενο καταχωρισμένο σε αυτόν τον χώρο αποθήκευσης',
      loadError: 'Αδυναμία φόρτωσης των περιεχομένων',
      colDetail: 'Λεπτομέρεια',
      manage: 'Διαχείριση στην ενότητά του',
      kind: {
        disk: 'Δίσκος',
        catalogFile: 'Αρχείο καταλόγου',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadata VM',
        appRoot: 'Root App',
        appVolume: 'Τόμος App'
      }
    },
    inventory: {
      tabCatalogs: 'Κατάλογοι',
      storage: 'Χώρος αποθήκευσης',
      sizeGib: 'Μέγεθος (GiB)',
      format: 'Μορφή',
      size: 'Μέγεθος',
      sourceType: 'Προέλευση',
      sourceFile: 'Μεταφόρτωση αρχείου',
      sourceUrl: 'Λήψη από URL',
      file: 'Αρχείο',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Υποχρεωτικό: η λήψη επαληθεύεται έναντι αυτού του SHA-256',
      verifyChecksum: 'Επαλήθευση checksum',
      checksumOffHint: 'Η λήψη θα γίνει δεκτή χωρίς επαλήθευση — το υπολογισμένο SHA-256 καταγράφεται ούτως ή άλλως',
      uploading: 'Μεταφόρτωση…',
      move: {
        action: 'Μετακίνηση',
        diskTitle: 'Μετακίνηση δίσκου',
        target: 'Χώρος αποθήκευσης προορισμού',
        diskHint: 'Ο δίσκος διατηρεί την ταυτότητά του: τα byte ταξιδεύουν στον επιλεγμένο χώρο αποθήκευσης. Μια VM που τον χρησιμοποιεί πρέπει να είναι απενεργοποιημένη· με υπάρχοντα στιγμιότυπα μια πλευρά iSCSI απορρίπτει τη μετακίνηση.',
        noTargets: 'Κανένας συμβατός χώρος αποθήκευσης προορισμού',
        submit: 'Μετακίνηση',
        error: 'Η μετακίνηση απορρίφθηκε'
      },
      clone: {
        action: 'Κλωνοποίηση',
        title: 'Κλωνοποίηση δίσκου',
        name: 'Όνομα του αντιγράφου',
        storage: 'Χώρος αποθήκευσης προορισμού',
        sameStorage: 'Ίδιος με την προέλευση',
        linked: 'Linked clone',
        linkedHint: 'Ακαριαίο overlay qcow2 αλυσοδεμένο στον δίσκο προέλευσης (μόνο προελεύσεις qcow2). Η προεπιλογή είναι ένα πλήρες αντίγραφο.',
        linkedCrossHint: 'Ένα linked clone μένει στον χώρο αποθήκευσης της προέλευσης: επιλέξτε «Ίδιος με την προέλευση» για να το ενεργοποιήσετε.',
        submit: 'Κλωνοποίηση',
        error: 'Η κλωνοποίηση απορρίφθηκε'
      },
      copy: {
        action: 'Αντιγραφή',
        name: 'Όνομα του αντιγράφου',
        storage: 'Χώρος αποθήκευσης προορισμού',
        sameStorage: 'Ίδιος με την προέλευση',
        submit: 'Αντιγραφή',
        error: 'Η αντιγραφή απορρίφθηκε'
      },
      taskStarted: 'Ξεκίνησε — συνεχίζει ως εργασία στο παρασκήνιο',
      cephObjects: 'Μετάβαση στις λεπτομέρειες αντικειμένου στο Ceph',
      phase: {
        ready: 'Έτοιμη',
        creating: 'Σε δημιουργία',
        'awaiting-upload': 'Σε αναμονή upload',
        downloading: 'Σε λήψη',
        verifying: 'Σε επαλήθευση',
        deleting: 'Σε διαγραφή',
        error: 'Σφάλμα',
        'in-use': 'Σε χρήση'
      }
    }
  }
}
